import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import AuthAxios from "../../config/authAxios"
import apiRoutes from "../apiConfigs"

export const podcastDetailsApi = createAsyncThunk(
    'auth/podcasts/details',
    async (id, { rejectWithValue }) => {
        try {
            const response = await AuthAxios.get(apiRoutes.podcastsAction(`${id}`, 1))
            return response?.data
        } catch (error) {
            return rejectWithValue(error?.response?.data)
        }
    }
)
const intialState = { result: [], loading: false, error: null, message: "" }
const podcastDetailsSlice = createSlice({
    name: 'podcast details',
    initialState: intialState,
    reducers: {
        resetPodcast: () => intialState,
    },
    extraReducers: (builder) => {
        builder.addCase(podcastDetailsApi.pending, (state, action) => {
            state.loading = true
        })
        builder.addCase(podcastDetailsApi.fulfilled, (state, action) => {
            state.loading = false
            state.result = action?.payload?.result
            state.message = action?.payload?.message
        })
        builder.addCase(podcastDetailsApi.rejected, (state, action) => {
            state.loading = false
            state.error = action?.payload?.error
            state.message = action?.payload?.message
        })
    },
})
export const { resetPodcast } = podcastDetailsSlice.actions;
export const podcastDetailsReducer = podcastDetailsSlice.reducer